/* global __ENV__ */

import AbacusClientUtils from '@homeaway/abacus-client-utils';
import {getHostName} from 'virtual-tour-viewer/src/utils/UIHelper';

function initializeAbacus(havId, hasId, abacusOverride) {
    // When running locally, grab the lab instance of the experiment data
    const hostName =
        __ENV__ === 'development' ? 'https://svc-stage.homeaway.com/havr-api' : getHostName();
    let promise = fetch(`${hostName}/experimentInfo?abov=${abacusOverride}`, {
        headers: {
            'X-HA-Visitor-Id': havId,
            'X-HA-Session-Id': hasId,
        },
    });

    return promise.then((response) => {
        let payload = response.json();
        return payload.then((abacusData) => {
            AbacusClientUtils.initialize(abacusData);
        });
    });
}

export {initializeAbacus};
